<template>
  <div class="digitalm">
    <div class="copywritingmbox">
        <div class="header">
            <img src="@/assets/mobile/back.png" alt="" @click="back()">
            <p @click="selecttc=!selecttc">照片数字人</p>
            <span @click="jumprouter('/history/2')">创作历史</span>
        </div>
        <div class="list" v-show="selecttc">
            <div class="listbox">
                <div class="swiper">
                    <swiper :options="swiperOption" ref="mySwiper">
                        <swiper-slide :class="swiperIndex == -1 ? 'swiperOn' : ''"
                            ><span data-id="0" :data-index="-1">全部</span></swiper-slide
                        >
                        <swiper-slide :class="swiperIndex==index?'swiperOn':''" v-for="(item,index) in swiperdata" :key="index"><span :data-id="item.id" :data-index="index">{{item.title}}</span></swiper-slide>
                    </swiper>
                </div>
                <el-scrollbar>
                    <ul>
                        <li v-for="(item,index) in list" :key="index" @click.stop="jumppage(item.type,item.id)">
                            <div class="icon"><img :src="item.image" alt=""></div>
                            <p :class="item.id == listdata.id?'on':''">{{item.title}}</p>
                        </li>
                    </ul>
                </el-scrollbar>
            </div>
        </div>

        <el-scrollbar>
            <div class="microvideombox">
                <div class="titlebox">
                    <div>
                        <p>01.</p>
                        <p>
                            <span>选择一张照片</span>
                            <span>请使用五官清晰的单人正脸照片</span>
                        </p>
                    </div>
                    <p class="po">第1步</p>
                </div>
                <ul class="avatar">
                    <li>
                        <el-upload
                            class="upload-demo"
                            drag
                            action=""
                               accept="image/jpg,image/jpeg,image/png"
                            :http-request="UploadImage"
                            :show-file-list="false">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">上传照片</div>
                        </el-upload>
                    </li>
					<el-image :preview-src-list="list1" style="width: 94px;height: 94px;" v-for="(item,index) in list1" fit="fill" :src="item" />
                </ul>
            </div>

            <div class="microvideombox">
                <div class="titlebox">
                    <div>
                        <p>02.</p>
                        <p>
                            <span>输入让视频说话的内容</span>
                            <span>您可以选择输入文字或上传语音音频</span>
                        </p>
                    </div>
                    <p class="po">第2步</p>
                </div>
                <div class="tab">
                    <p :class="tab?'on':''" @click="tab=true">输入文字</p>
                    <p :class="!tab?'on':''" @click="tab=false">上传语音</p>
                </div>
                <div v-if="tab">
                    <div class="form">
                        <div>
                            <!-- <p class="this">文案</p> -->
                            <el-input type="textarea" maxlength="200" v-model="voiceForm.content" placeholder="想要照片说些什么内容？请写在这里吧" show-word-limit></el-input>
                        </div>
                        <p class="tip">没有灵感？插入范文</p>
                    </div>
                    <div class="select">
                        <div class="selectbox" @click="claritytc=true">
                            <p>选择配音角色</p>
                            <p>{{form.juese}}</p>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                        <el-drawer
                        size="80%"
                        direction="btt"
                        :visible.sync="claritytc"
                        title="选择配音角色"
                        :show-close="true"
                        >
                            <div class="content-wrap">
                                <div class="content-box">
                                    <div>
                                        <el-scrollbar>
                                            <ul class="left">
                                                <li :class="['tags-box',alitypeindex==item.id?'this':'']" @click="changeRole(item.id)" v-for="(item,index) in alitype" :key="index">{{item.title}}</li>
                                            </ul>
                                        </el-scrollbar>
                                    </div>
                                    <div class="content-divider"></div>
                                    <div class="right">
                                        <el-scrollbar>
                                            <ul>
                                                <li v-if="alitypeindex != 10000" v-for="(item,index) in ali" :key="index" :class="voiceForm.model_id==item.id?'on':''" @click="selectmodel(item)">
                                                    <div><img :src="item.image" alt=""></div>
                                                    <div>{{item.role_name}}</div>
                                                    <div>{{item.description}}</div>
                                                </li>
												<li v-if="alitypeindex == 10000" v-for="(item,index) in ali" :key="index" :class="voiceForm.model_id==item.id?'on just-asd':'just-asd'" @click="selectmodel(item)">
												    <div>{{item.title}}</div>
												</li>
												<li v-if="alitypeindex == 10000 && ali.length == 0"  class="on just-asd" @click="jumpClone()">
												    <div>定制声音克隆</div>
												</li>
                                            </ul>
                                        </el-scrollbar>
                                    </div>
                                </div>
                            </div>
                        </el-drawer>
                    </div>
                    <div class="slider">
                        <p>音量</p>
						<el-button size="mini" icon="el-icon-minus" @click="decreaseVolume(-1)"></el-button>
                        <el-slider v-model="voiceForm.volume" :min='0' :max='100'></el-slider>
                        <p>{{voiceForm.volume}}</p>
						<el-button size="mini" icon="el-icon-plus" @click="decreaseVolume(1)"></el-button>
                    </div>
                    <div class="slider">
                        <p>语速</p>
						<el-button size="mini" icon="el-icon-minus" @click="decreaseSpeed(-10)"></el-button>
                        <el-slider v-model="voiceForm.speed" :min='-500' :max='500'></el-slider>
                        <p>{{voiceForm.speed}}</p> 
						<el-button size="mini" icon="el-icon-plus" @click="decreaseSpeed(10)"></el-button>
                    </div>
                    <div class="slider">
                        <p>语调</p>
						<el-button size="mini" icon="el-icon-minus" @click="decreaseIntonation(-10)"></el-button>
                        <el-slider v-model="voiceForm.intonation" :min='-500' :max='500'></el-slider>
                        <p>{{voiceForm.intonation}}</p>
						<el-button size="mini" icon="el-icon-plus" @click="decreaseIntonation(10)"></el-button>
                    </div>
                    <div @click="createflie" class="button">生成语音</div>
                </div>
                <div v-else class="uploadbox">
                    <el-upload
                        class="upload-demo"
                        :limit="1"
                        drag
                        action=""
                        accept="audio/mpeg,audio/wav,audio/x-wav"
                        :http-request="uploadVoice"
                        :show-file-list="true"
                        :file-list="videoList">
                        <div class="box">
                            <div>
                                <p>上传语音音频</p>
                                <p>支持mp3/wav格式，时长20秒</p>
                            </div>
                            <div><i class="el-icon-upload"></i></div>
                        </div>
                    </el-upload>
                </div>
            </div>
        </el-scrollbar>
        <div class="create">
          <!--  <p>每日免费使用  <span>{{count}}</span>次 <i class="el-icon-question"></i></p> -->
            <div @click="createvideo">立即生成</div>
        </div>
        <voiceplay
        v-if="voiceplaystatus"
        @colsevideo="colsevideo"
        :audioUrl="videoForm.voice_url"
        ></voiceplay>
    </div>
  </div>
</template>

<script>
import { getIndexData } from "@/api/index";
import voiceplay from "@/components/voiceplay";
import {uploadUploadImage,voiceGetModelList,voiceGenerate,uploadUploadVoice,videoCreate} from "@/api/video"
export default {
    components: {
        voiceplay
    },
    data(){
        return {
            params: {
                cid: 0,
                keyword: "",
            },
            videoplaystatus:true,
            voiceplaystatus:false,
            videoList:[],
            voiceForm:{
                content:"",
                volume:50,
                speed:1,
                intonation:1,
                model_id:"",
                creation_id:2//数字人
            },
            videoForm:{
                content:"",
                tid:"",
                video_url:"",
                voice_url:"",
                creation_id:2
            },
            tab:true,
            count:2,
            juesetc:false,
            claritytc:false,
            form:{
                clarity:"标清(576p)",
                title:"",
                content:"",
                conclusion:"谢谢观看",
                juese:"",
            },
            claritylist:[
                "标清(576p)",
                "高清(720P)",
                "超清(1080P)",
            ],
            selecttc:false,
            swiperIndex:0,
            swiperOption:{
                slidesPerView:5,
                spaceBetween : 8,
                on: {
                    click: (e) =>  {
                        this.swiperClick(e)
                    }
                }
            },
            listdata:{},
            swiperdata:[
            ],
            list:[],
            listindex:0,
            list1:[],
            alitypeindex:10000,
            alitype:[],
            ali:[],
            currentType:1,
        }
    },
    mounted(){
        this.voiceGetModelList()
        this.getIndexData()
    },
    methods:{
		decreaseVolume(v) {
			if(this.voiceForm.volume >= 100 || this.voiceForm.volume <=0) {
				return;
			} 
			this.voiceForm.volume = this.voiceForm.volume + v;
		},
		decreaseSpeed(v) {
			if(this.voiceForm.speed >= 500 || this.voiceForm.speed <= -500) {
				return;
			} 
			this.voiceForm.speed = this.voiceForm.speed + v;
		},
		decreaseIntonation(v) {
			if(this.voiceForm.intonation >= 500 || this.voiceForm.intonation <= -500) {
				return;
			} 
			this.voiceForm.intonation = this.voiceForm.intonation + v;
		},
        getIndexData() {
            var that = this;
            getIndexData(this.params).then((response) => {
                // console.log(response)
                that.swiperdata = response.data.category;
                // that.list = response.data.template;
            });
        },
		jumpClone(){
		    this.$router.push({ path: '/clone'});
		},
         createflie(){
            // this.videoplaystatus=true
            // if(this.tab){
                if(this.voiceForm.content==""){
                    this.$message.error('文本不能为空');
                    return false
                }
                const loading1 = this.$loading({
                    lock: true,
                    text: '语音生成中....',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                voiceGenerate(this.voiceForm).then(res=>{
                    loading1.close()
                    this.videoForm.voice_url = res.data.url
                    this.voiceplaystatus =true
                    // this.createvideo()
                })
            // }else{
            //     this.createvideo()
            // }
        },
        createvideo(){
            this.videoForm.content = this.voiceForm.content
            if(!this.tab){
                this.videoForm.voice_url = this.videoList[0]
            }
            if(this.videoForm.voice_url==""){
                this.$message.error("语音文件不能为空");
                return false;
            } 
            this.videoForm.video_url = this.list1[this.listindex]
            if(this.videoForm.video_url==""){
                this.$message.error("视频文件不能为空");
                return false;
            } 
            videoCreate(this.videoForm).then(res=>{
				if(res.code == 1) {
					this.$message.error(res.message)
				}else {
					this.videoid = res.data.id
					this.videoplaystatus = true
					this.$router.push({ path: 'videoplaym/'+this.videoid })
				}
               
            })
        },
        colsevideo() {
            this.voiceplaystatus = false;
        },
        selectmodel(item){
            this.voiceForm.model_id = item.id
            this.form.juese = item.role_name
            this.claritytc = false
        },
        changeRole(id){
            this.alitypeindex = id
            this.voiceGetModelList()
        },
        voiceGetModelList(){
            voiceGetModelList({cid:this.alitypeindex}).then(res=>{
                this.alitype = res.data.category_list
                this.ali = res.data.model_list
				if(this.ali != null && this.ali.length > 0) {
					this.voiceForm.model_id = this.ali[0].id
				}
            })
        },
        uploadVoice(e){
             const loading2 = this.$loading({
                lock: true,
                text: '文件上传中....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const formData = new FormData()
            formData.append('file', e.file)
            uploadUploadVoice(formData).then(res=>{
                loading2.close();
                this.videoList[0] = res.data.fullurl
            })
        },
        UploadImage(e){
            const loading3 = this.$loading({
                lock: true,
                text: '文件上传中....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const formData = new FormData()
            formData.append('file', e.file)
            uploadUploadImage(formData).then(res=>{
                loading3.close();
				this.list1 = [];
                this.list1.push(res.data.fullurl)
            })
        },
        jumprouter(router){
            this.$router.push({ path: router })
        },
        back(){
            this.$router.back()
        },
        swiperClick(e){
            this.params.cid = e.target.getAttribute("data-id");
            this.swiperIndex = e.target.getAttribute("data-index");
            this.getIndexData();
        },
        jumppage(type, id) {
            this.selecttc = false;
            if (type == 2) {
                this.$router.push({ path: "/copywriting/" + id });
                location.reload();
            } else if (id == 1) {
                this.$router.push({ path: "/microvideo" });
            } else if (id == 2) {
                this.$router.push({ path: "/digital" });
            } else if (id == 3) {
                this.$router.push({ path: "/face" });
            }else if (id == 4) {
				this.$router.push({ path: "/clone" });
			}
        },
    }
}
</script>

<style lang="less">
    .digitalm{
        background-color: #f4f5f7;
        min-height: 100vh;
        .el-scrollbar{
            height: calc(100vh - 160px);
            .el-scrollbar__wrap{
                overflow-x: hidden;
            }
        }
        .copywritingmbox{
            .el-drawer__header{
                margin-bottom: 10px;
            }
            .content-box{
                height: 430px;
                overflow-y: scroll;
                display: flex;
                .content-divider{
                    width: 1px;
                    margin: 0 16px;
                    background: #e6e9ed;
                }
                .left{
                    padding:0 10px;
                }
                .tags-box{
                    text-align: center;
                    padding: 5px 12px;
                    border-radius: 6px;
                    background: #fff;
                    flex-shrink: 0;
                    cursor: pointer;
                    position: relative;
                    font-size: 14px;
                    color: #333;
                }
                .this{
                    background: #f4f5f7;
                }
                .right{
                    flex:1 0 10%;
                    // padding: 20px 0;
                    img{
                        width: 100%;
                        border-radius: 8px;
                    }
                    li{
                        width: 98%;
                        height: 48px;
                        border: 1px solid #f4f5f7;
                        background-color: #f4f5f7;
                        border-radius: 8px;
                        margin: 5px 0;
                        padding: 0 8px;
                        cursor: pointer;
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: space-betweenc;
                        font-size: 14px;
                        color: #333;
                        img{
                            width: 28px;
                            margin: 0 8px;
                        }
                        div:nth-child(3){
                            flex: 1 0 10%;
                        }
                        div:nth-child(2){
                            margin-right: 12px;
                            padding-right: 12px;
                            position: relative;
                            border-right: 1px solid #ddd;
                        }
                    }
					.just-asd{
						justify-content: center;
					}
                    .on{
                        border: 1px solid #2d8af5;
                        background-color: #2d8af5;
                        color: #fff;
                    }
                }
            }
            .header{
                display: flex;
                align-items: center;
                height: 60px;
                img{
                    height: 18px;
                    padding: 0 20px;
                }
                p{
                    flex:1 0 10%;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 700;
                    padding-left: 20px;
                }
                span{
                    width: 82px;
                    height: 26px;
                    background-image: url(data:image/png;base64,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);
                    font-size: 12px;
                    color: #2f417b;
                    line-height: 26px;
                    text-align: center;
                }
            }
            .list{
                position: fixed;
                top: 60px;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,.533);
                z-index: 1;
                .listbox{
                    background-color: #fff;
                    border-radius: 0 0 14px 14px;
                    .el-scrollbar{
                        height: 360px;
                        .el-scrollbar__wrap{
                            overflow-x: hidden;
                        }
                    }
                    .swiper{
                        height: 42px;
                        padding: 0 8px;
                        .swiper-container{
                            height: 100%;
                            .swiper-wrapper{
                                height: 100%;
                                .swiper-slide{
                                    height: 100%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                }
                                .swiperOn{
                                    color: #2d8af5;
                                }
                            }
                        }
                    }
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                        padding: 20px 0;
                        li{
                            flex: 0 0 23%;
                            text-align: center;
                            font-size: 12px;
                            .icon{
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                padding: 6px;
                                width: 32px;
                                height: 32px;
                                background: #fff;
                                box-shadow: 0 1px 3px rgba(0,0,0,.06);
                                border-radius: 8px;
                                margin:0 auto 4px;
                                img{
                                    width: 100%;
                                }
                            }
                        }
                        .on{
                            color: #2d8af5;
                        }
                    }
                }
            }
            .microvideombox{
                background-color: #fff;
                border-radius: 12px;
                position: relative;
                overflow: hidden;
                padding: 20px;
                margin: 0 20px 16px;
                .button{
                    width: 223px;
                    height: 50px;
                    border-radius: 25px;
                    font-size: 16px;
                    font-weight: 700;
                    background-image:linear-gradient(106.92deg, rgb(16, 197, 254) 14.83%, rgb(16, 147, 254) 31.52%, rgb(79, 79, 231) 65.11%, rgb(182, 12, 185) 91.29%, rgb(224, 202, 245) 102.83%);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin:4px auto;
                    color: #fff;
                }
                .titlebox{
                    display: flex;
                    justify-content: space-between;
                    div{
                        display: flex;
                        align-items: center;
                        p:nth-child(1){
                            color: #678bfe;
                            font-size: 20px;
                            font-weight: 700;
                            margin-right: 8px;
                        }
                        p:nth-child(2){
                            span{
                                display: block;
                            }
                            span:nth-child(1){
                                font-size: 16px;
                                font-weight: 700;
                                margin-bottom: 4px;
                                margin-bottom: 4px;
                            }
                            span:nth-child(2){
                                color: #999;
                                font-size: 12px;
                            }
                        }
                    }
                    .po{
                        position: absolute;
                        top: 0;
                        right: 0;
                        background: linear-gradient(180deg,#8fa7fe -52.34%,#4774fe 161.39%,#a8b6ff 285.34%),#4192f7;
                        box-shadow: 0 -1px 6px rgba(81,128,250,.9);
                        color: #fff;
                        font-size: 12px;
                        padding: 3px 12px;
                        text-indent: 6px;
                        border-end-start-radius: 24px;
                        border-start-end-radius: 12px;
                        letter-spacing: 1px;
                    }
                }
                .avatar{
                    display: flex;
                    gap: 8px;
                    flex-wrap: wrap;
                    margin-top: 12px;
                    li{
                        flex:0 0 31%;
                        .upload-demo{
                            .el-upload{
                                width: 100%;
                            }
                            .el-upload-dragger{
                                width: 100%;
                                height: 94px;
                                display: block;
                                i{
                                    font-size: 32px;
                                    margin: 10px 0 0 0;
                                }
                            }
                        }
                    }
                    .videobox{
                        div{
                            width: 100%;
                            height: 94px;
                            overflow: hidden;
                            border-radius: 9px;
                            position: relative;
                            display: block;
                            video{
                                position: absolute;
                                left: 50%;
                                top: 50%;
                                transform: translate(-50%,-50%);
                                display: block;
                                width: 100%;
                                // height: 100%;
                                cursor: pointer;
                                position: relative;
                                z-index: 10;
                            }
                        }
                    }
                    .on{
                        display: block;
                        border: 2px solid #2d8af5;
                    }
                }
                .tab{
                    width: 156px;
                    margin: 12px auto;
                    padding: 4px;
                    background-color: #f4f5f7;
                    border-radius: 38px;
                    display: flex;
                    p{
                        flex: 0 0 50%;
                        color: #666;
                        padding: 5px 10px;
                        cursor: pointer;
                        // z-index: 1;
                        font-size: 12px;
                        text-align: center;
                    }
                    .on{
                        border-radius: 38px;
                        background-color: #fff;
                    }
                }
                .select{
                    .selectbox{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        background-color: #f4f5f7;
                        border-radius: 8px;
                        padding: 18px 16px;
                        p:nth-child(1){
                            font-size: 14px;
                            color: #333;
                            font-weight: 700;
                        }
                        p:nth-child(2){
                            flex: 1 0 10%;
                            text-align: right;
                            font-size: 14px;
                            color: #333;
                            margin-right: 4px;
                        }
                    }

                    .popup{
                        padding: 24px;
                        .popuptitle{
                            font-size: 16px;
                            color: #666;
                            text-align: center;
                            margin-bottom: 24px;
                        }
                        ul{
                            li{
                                // padding: 0 24px;
                                height: 56px;
                                font-size: 16px;
                            }
                            .on{
                                color: #2d8af5;
                            }
                        }
                        .el-button{
                            width: 100%;
                            background-color: #f4f4f4;
                        }
                    }
                }

                .form{
                    margin-top: 24px;
                    >div{
                        padding-bottom: 20px;
                    }
                    p{
                        font-size: 14px;
                        color: #333;
                        margin-bottom: 12px;
                    }
                    .tip{
                        color: #999;
                        font-size: 12px;
                    }
                    .this::before{
                        content: "*";
                        color: #ff5556;
                        margin-right: 4px;
                    }
                    .el-input__inner,.el-textarea__inner{
                        background: #f4f5f7;
                        border: 1px solid #f4f5f7;
                        border-radius: 8px;
                        padding: 4px 10px;
                    }
                    .el-textarea__inner{
                        height:120px
                    }
                    .el-input__count-inner,.el-input__count{
                        background: #f4f5f7;
                    }
                }
            }

            .slider{
                display: flex;
                align-items: center;
                .el-slider{
                    flex: 1 0 10%;
                    margin: 0 20px;
                }
            }

            .uploadbox{
                .upload-demo{
                    min-height: 88px;
                    border-radius: 8px;
                    background: #f4f5f7;
                    padding: 0 16px;
                    position: relative;
                    overflow: hidden;
                    .el-upload{
                        width: 100%;
                        height: 100%;
                    }
                    .el-upload-dragger{
                        background: transparent;
                        border: none;
                        width: 100%;
                        height: 100%;
                    }
                }
                .box{
                    display: flex;
                    align-items: center;
                    height: 88px;
                    justify-content: space-between;
                    i{
                        font-size: 32px;
                        margin: 0;
                    }
                    div:nth-child(1){
                        flex: 1 0 10%;
                        text-align: left;
                        p:nth-child(1){
                            font-size: 14px;
                            color: #333;
                        }
                        p:nth-child(2){
                            color:#999;
                            font-size: 12px;
                        }
                    }
                    div:nth-child(2){
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 56px;
                        height: 56px;
                        border-radius: 8px;
                        background-color: #fff;
                    }
                }
            }

            .create{
                background-color: #fff;
                height: 100px;
                padding-top: 16px;
                p{
                    text-align: center;
                    height: 25px;
                    color: #999;
                    font-size: 12px;
                    span{
                        color: #2d8af5;
                    }
                    i{
                        font-size: 16px;
                    }
                }
                div{
                    width: 223px;
                    height: 50px;
                    border-radius: 25px;
                    font-size: 16px;
                    font-weight: 700;
                    background-image:linear-gradient(106.92deg, rgb(16, 197, 254) 14.83%, rgb(16, 147, 254) 31.52%, rgb(79, 79, 231) 65.11%, rgb(182, 12, 185) 91.29%, rgb(224, 202, 245) 102.83%);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin:4px auto;
                    color: #fff;
                }
            }
        }
    }
</style>